import React from 'react';
import classNames from "classnames";
import PropTypes from "prop-types";
import Icon from "./Icon";
import {isTrue} from "../../utils/other";

class CheckBox extends React.Component {

    static defaultProps = {
        type: "bool",
        disabled: false,
        required: false
    }

    static propTypes = {
        name: PropTypes.any,
        value: PropTypes.any,
        disabled: PropTypes.bool,
        style: PropTypes.any,
        className: PropTypes.any,
        error: PropTypes.any,
        checked: PropTypes.bool,
        label: PropTypes.any,
        required: PropTypes.bool,
        saveChanges: PropTypes.func,
        onIcon: PropTypes.shape(Icon.propTypes),
        offIcon: PropTypes.shape(Icon.propTypes),
        type: PropTypes.oneOf(["bool", "option"]),
        options: PropTypes.object,
    }

    onChange = (e) => {
        if (!this.props.disabled) {
            let v = null;
            if (this.props.type === "bool") {
                v = !this.isChecked();
            } else if (this.props.type === "option") {
                if (!this.isChecked()) {
                    v = this.props.value;
                }
            } else {
                v = this.props.options[!(Object.keys(this.props.options)[this.props.options.indexOf(this.props.value)] || false)];
            }
            this.props.saveChanges && this.props.saveChanges(this.props.name, v, e);
        }
    }

    isChecked = () => {
        let checked = false;
        if (this.props.checked !== undefined) {
            checked = this.props.checked;
        } else {
            if (this.props.type === "bool") {
                checked = isTrue(this.props.value) || !!parseInt(this.props.value);
            } else {
                checked = !!(Object.keys(this.props.options)[this.props.options.indexOf(this.props.value)] || false);
            }
        }
        return checked;
    }

    render() {
        const checked = this.isChecked();
        let icon = null;
        if (this.props.onIcon !== undefined && this.props.offIcon !== undefined) {
            icon = <Icon {...(checked ? this.props.onIcon : this.props.offIcon)} />
        } else {
            icon = <span
                className={classNames("p-checkbox-icon p-c", {"pi pi-check": checked})} />;
        }
        return <div className={classNames("checkbox", this.props.className)} style={this.props.style} onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            this.onChange(e);
        }}>
            <label className={classNames({"is-invalid": this.props.error})}>
                <div className={classNames("p-checkbox p-component", {"p-disabled": this.props.disabled})}>
                    <div className="p-hidden-accessible">
                        <input type="checkbox"
                               name={this.props.name}
                               checked={checked}
                               value={this.props.value}
                               disabled={this.props.disabled || false}
                               onChange={this.onChange}
                        />
                    </div>
                    <div className={classNames("p-checkbox-box p-component",{"p-highlight": checked})}>{icon}</div>
                </div>
                {this.props.label} {this.props.required && <span className="invalid-feedback">*</span>}
            </label>
            {this.props.error && <div className="invalid-feedback">{this.props.error}</div>}
        </div>
    }
}

export default CheckBox;